(function () {
    const RESTRICTED_HANDLES = [
        'omega-3-focus-60-capsulas-nutriage',
        'omega-3-focus-3-potes',
        'v-max-3-1',
        'vision-max-3-3-potes',
        'hair-max-5-1',
        'hair-max-5-3',
        'neuro-fox-pro-60-caps-1',
        ''
    ];

    // Limite em QUANTIDADE DE POTES (não em unidades de variante).
    // Cliente pode comprar: 1 kit de 3 potes OU 3 produtos de 1 unidade.
    const LIMIT = 3;

    // Quantos potes cada handle representa por unidade comprada.
    const POTES_BY_HANDLE = {
        'omega-3-focus-60-capsulas-nutriage': 1,
        'omega-3-focus-3-potes': 3,
        'v-max-3-1': 1,
        'vision-max-3-3-potes': 3,
        'hair-max-5-1': 1,
        'hair-max-5-3': 3,
        'neuro-fox-pro-60-caps-1': 1
    };

    // Exceção: teto de UNIDADES por handle, independente do limite geral de potes.
    // Ex.: 'v-max-3-1': 1 => no máximo 1 unidade desse handle no carrinho.
    const MAX_UNITS_BY_HANDLE = {
        'v-max-3-1': 1,
        'hair-max-5-1': 1,
        'neuro-fox-pro-60-caps-1': 1
    };

    let cachedCartItems = [];

    function isRestricted(handle) {
        return RESTRICTED_HANDLES.includes(handle);
    }

    // Quantos potes um handle vale. Usa o mapa; se for um handle novo,
    // tenta deduzir pelo final do handle (-N-potes ou -N), senão 1.
    function potesForHandle(handle) {
        if (POTES_BY_HANDLE[handle] != null) return POTES_BY_HANDLE[handle];
        const m = String(handle).match(/-(\d+)-potes$/) || String(handle).match(/-(\d+)$/);
        return m ? Number(m[1]) : 1;
    }

    // Soma o total de POTES dos itens restritos no carrinho.
    function countTotalPotes(items) {
        return items.reduce((total, item) => {
            if (!isRestricted(item.handle)) return total;
            return total + potesForHandle(item.handle) * item.quantity;
        }, 0);
    }

    // Soma as unidades de um handle específico no carrinho.
    function countUnitsForHandle(items, handle) {
        return items.reduce(
            (total, item) => (item.handle === handle ? total + item.quantity : total),
            0
        );
    }

    function getSelectedHandle() {
        const qb = document.querySelector('quantity-bundle');
        if (qb) {
            const selected = qb.querySelector('.qb-card.is-selected');
            if (selected?.dataset.productHandle) return selected.dataset.productHandle;
        }
        const form = document.querySelector('product-form[data-product-handle]');
        return form?.dataset.productHandle ?? null;
    }

    // true se adicionar a seleção atual estouraria o limite de potes
    // OU o teto de unidades específico do handle (exceção).
    function wouldExceedLimit(handle) {
        const cap = MAX_UNITS_BY_HANDLE[handle];
        if (cap != null && countUnitsForHandle(cachedCartItems, handle) + 1 > cap) {
            return true;
        }
        return countTotalPotes(cachedCartItems) + potesForHandle(handle) > LIMIT;
    }

    function updatePdpButton() {
        const btn = document.querySelector('.product__info-container .product-form__submit');
        if (!btn) return;

        const handle = getSelectedHandle();

        if (!handle || !isRestricted(handle)) {
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('cart-limit--blocked');
            return;
        }

        const blocked = wouldExceedLimit(handle);

        btn.disabled = blocked;
        if (blocked) {
            btn.setAttribute('aria-disabled', 'true');
        } else {
            btn.removeAttribute('aria-disabled');
        }
        btn.classList.toggle('cart-limit--blocked', blocked);
    }

    // Handler do evento pub-sub — entry point principal.
    // O payload do cartUpdate (ex.: add.js do product-form) traz só o item
    // recém-adicionado, não o carrinho completo. Por isso buscamos /cart.js
    // para ter o total real de potes do carrinho.
    function onCartUpdate() {
        fetchCart();
    }

    async function fetchCart() {
        try {
            const r = await fetch('/cart.js');
            const cart = await r.json();
            cachedCartItems = cart.items ?? [];
            updatePdpButton();
        } catch (_) { }
    }

    function init() {
        // Evento principal: qualquer alteração no carrinho (add, remove, change)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
        }

        // Bloqueio no submit (capture phase) com base no cache local
        document.addEventListener(
            'submit',
            (e) => {
                const form = e.target;
                if (!form.matches('[data-type="add-to-cart-form"]')) return;

                const handle = getSelectedHandle();
                if (!handle || !isRestricted(handle)) return;

                if (wouldExceedLimit(handle)) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    updatePdpButton();
                }
            },
            true
        );

        // Atualiza botão quando cliente troca de card no quantity-bundle
        document.addEventListener('quantity-bundle:change', () => {
            updatePdpButton();
        });

        // Estado inicial: aguarda o bundle renderizar e busca o carrinho se necessário
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const handle = getSelectedHandle();
                if (handle && isRestricted(handle)) {
                    fetchCart();
                } else {
                    updatePdpButton();
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
